import React from 'react';
import StepTitle from '../components/StepTitle';

const UserVerified = () => {
  return (
    <div className='flex flex-col justify-between p-6 md:mt-16 md:mx-auto md:p-0 md:h-auto md:max-w-3xl h-window bg-white relative md:top-1/4 overflow-y-auto md:overflow-y-hidden overflow-x-hidden z-20'>
      <div className='divide-y-2 divide-black divide-opacity-50 z-10 h-full'>
        <div>
          <StepTitle stepTitleContent={'Email verified'} />
        </div>
        <div>
          <p className='pb-0 pt-8 pl-0 text-base w-[450px] font-normal'>
            Thanks for verifying the email associated with your account!
          </p>
          <p className='pt-0 pb-8 pl-0 text-base w-[450px] font-normal'>
            You’re ready to log in and run some simulations.
          </p>
          <button
            className='my-4 py-2 px-4 hover border-2 hover:text-dms-primary hover:border-2 hover:border-dms-primary hover:bg-white text-lg font-medium cursor-pointer transition duration-100 rounded-md z-10 bg-dms-primary text-white'
            type='submit'
            onClick={() => window.location.replace('/')}
          >
            Log in to DMS Academy Sims
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserVerified;
